<template>
  <div class="card">
    <div class="card-body" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <form @submit="submit" class="add-edit-form product-form">
              <div class="row">
                <div class="col-lg-6">
                  <label for>
                    <span>Blog Title:</span>
                    <input v-model="blog.title" type="text" class="form-control" />
                  </label>
                  <label for>
                    <span>Blog Description:</span>
                    <textarea v-model="blog.description" type="text" class="form-control" rows="6"/>
                  </label>
                  <label for>
                    <span>Blog Image</span>
                    <section class="form-control replace" :class="{'d-none': !isObject(blog.image)}">
                      <input type="button" class="replace-btn" data-id="image" value="Replace File">
                      <span>{{blog.image}}</span>
                    </section>
                    <input :class="{'d-none': isObject(blog.image)}" @change="onFileChange($event, 'image')" type="file" id="image" class="form-control" />
                  </label>
                  <label for="" class="checkbox-icon">
                    <span class="text-left">Is Main Blog:</span>
                    <label class="checkbox-container">
                      <input v-model="blog.is_main_blog" type="checkbox">
                      <span class="checkmark"></span>
                    </label>
                  </label>
                </div>
                <div class="col-lg-6">
                  <div class="thumbnail-display"></div>
                </div>
              </div>
              <div class="col-lg-12 d-flex justify-content-center mt-3">
                <button type="submit" :disabled="this.$store.getters.apiStatus == 'loading'" class="btn btn-success">
                  <div v-if="this.$store.getters.apiStatus != 'loading'">{{toEdit ? 'Update' : 'Save'}}</div>
                  <div v-else class="loader"><Loader></Loader></div>
                </button>
              </div>
            </form>
          </div>
          <div class="col-lg-6"></div>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import Blog from '@/models/Blog'
export default{
  name: 'BlogForm',
  data () {
    return {
      blog: new Blog()
    }
  },
  computed: {
    toEdit () {
      return this.$route.params.id !== undefined
    }
  },
  mounted () {
    if (this.toEdit) {
      this.fetchBlog()
    }
    $('.thumbnail-display').click(function () {
      $('#thumbnail').click()
    })

    $(document).on('change', '#image', function () {
      if (event.target.files.length) { $('.thumbnail-display').css('background-image', 'url(' + window.URL.createObjectURL(event.target.files[0]) + ')') } else { $('.thumbnail-display').css('background-image', 'none') }
    })

    $('.card').on('click', '.replace-btn', function () {
      var id = $(this).attr('data-id')
      $('#' + id).click()
    })
  },
  methods: {
    fetchBlog () {
      this.$store.dispatch('fetchBlog', this.$route.params.id)
        .then((result) => {
          this.blog = new Blog(result.data.blog)
          $('.thumbnail-display').css('background-image', 'url("' + this.blog.imageUrl + '")')
        })
        .catch((err) => this.$helper.catchHandler(err))
      return null
    },
    submit (event) {
      event.preventDefault()
      var blog = this.blog.getFormData()
      var functionName = 'createBlog'
      var successText = 'created'
      if (this.toEdit) { functionName = 'editBlog'; successText = 'edited' }
      this.$store.dispatch(functionName, blog)
        .then(() => {
          this.$router.push('/blogs')
          this.$toast.success('Blog ' + successText + ' successfully')
        })
        .catch((err) => {
          console.log(err.response)
          this.$toast.error(err.response.data.message || 'An unkown error occured please contact suppport')
        })
    },
    onFileChange (e, index) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.blog[index] = null
        index = null
      } else { this.blog[index] = files[0] }
    },
    isObject (val) {
      if (this.toEdit && !(val === 'null' || val === '')) { return true }
      return (typeof val === 'object')
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 767px) {
  .cat-div {
    width: 100% !important;
  }
}
.thumbnail-display {
  background-size: contain !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BlogForm.vue